import { VehicleDataEnum } from '../../../../core/consts/vehicle-data.enum';
import { InsuranceDataEnum } from '../../../../core/consts/insurance-data.enum';
import { VehicleQuestionCode } from '../../../../core/consts/vehicle-question-code.enum';
import { FormConfig } from '../../../models/form-config';
import { FieldType } from '../../../models/field-type';
import { VehicleDataStateService } from '../../../../core/services/impl/section-services/vehicle-data/vehicle-data-state.service';
import { SelectContentText } from '../../../components/fields/multiselect/material-multiselect.component';
import { BeanConfig } from '../../../models/bean-config';
import { VehicleQuestionAnswer } from '../../../../core/consts/vehicle-question-answer.enum';
import { InsuranceDataStateService } from '../../../../core/services/impl/section-services/vehicle-data/insurance-data-state.service';
import { VehicleStateEnum } from '../../../../core/consts/vehicle-state.enum';
import { VehicleStateStateService } from '../../../../core/services/impl/section-services/vehicle-data/vehicle-state-state.service';
import { PredefinedValuesService } from '../../../../core/services/impl/section-services/predefined-values/predefined-values.service';
import { Validator } from '../../../models/validator.enum';
import {VehicleModelConsts} from '../../../../core/consts/vehicle-model.consts';
import {isNext} from '../../../../core/utils/utils';
import {VehicleAbroadImported} from '../../../../core/consts/vehicle-abroad-imported.enum';
import {OwnerDataConsts} from '../../../../core/consts/owner-data.consts';
import {DatepickerStartView} from '../../../enums/datepicker-start-view.enum';
import {MaterialDatepickerType} from '../../../enums/material-datepicker-type.enum';
import {getDrivingLicenseIssueYears} from '../../../utils/driving-license-years';
import {currentYear} from '../../../utils/time-utils';

export class VehicleUseSectionConfig {

    isNext = isNext();

    constructor(private vehicleDataStateService: VehicleDataStateService,
                private predefined: PredefinedValuesService,
                private insuranceDataStateService: InsuranceDataStateService,
                private vehicleStateStateService: VehicleStateStateService) { }

    createBeanConfig(fieldKey: string): BeanConfig {
        return {
            propertyName: 'questions',
            keyPropertyName: 'questionCode',
            valuePropertyName: 'questionAnswer',
            keyPropertyValue: VehicleQuestionCode[fieldKey]
        };
    }

    createVehicleUseConfig(): FormConfig {
        let formConfig = <FormConfig>{
            formKey: 'VEHICLE_USE_SECTION',
            fieldsConfig: [
                {
                    fieldKey: VehicleStateEnum.PARKING_PLACE,
                    caption: 'VEHICLE_USE_SECTION.FORM_FIELDS.parkingPlace',
                    type: FieldType.Select,
                    displayInPreviewMode: true,
                    validators: [Validator.REQUIRED],
                    options: {
                        item: 'key',
                        label: { label: 'label' },
                        items: this.vehicleStateStateService.parkingPlaceDictionary.items,
                    },
                    select: {
                        dropdownPosition: 'bottom',
                        multiple: false,
                        searchable: true
                    }
                },
                {
                    fieldKey: VehicleStateEnum.USAGE_TYPE,
                    caption: 'VEHICLE_USE_SECTION.FORM_FIELDS.usageType',
                    type: FieldType.Select,
                    validators: [Validator.REQUIRED],
                    displayInPreviewMode: true,
                    options: {
                        item: 'key',
                        label: { label: 'label' },
                        items: this.vehicleStateStateService.usageTypeDictionary.items,
                    },
                    select: {
                        dropdownPosition: 'bottom',
                        multiple: false,
                        searchable: true
                    },
                    initialValue: this.vehicleStateStateService.usageTypeDictionary.items.find(item => item.key === 'PRIVATE').value
                },
                {
                    fieldKey: VehicleStateEnum.AVG_MILEAGE_PER_YEAR,
                    caption: 'VEHICLE_USE_SECTION.FORM_FIELDS.avgMileagePerYear',
                    type: FieldType.Select,
                    displayInPreviewMode: true,
                    validators: [Validator.REQUIRED_NOT_BLANK],
                    options: {
                        item: 'key',
                        label: {label: 'label'},
                        items: this.vehicleStateStateService.avgMileagePerYearDictionary ? this.vehicleStateStateService.avgMileagePerYearDictionary.items : [],
                    },
                    select: {
                        contentTextType: SelectContentText.CAPTION_TEXT,
                        dropdownPosition: 'bottom',
                        multiple: false,
                        searchable: true
                    }
                },
                {
                    fieldKey: VehicleStateEnum.IS_ABROAD,
                    fieldsDataFormat: 'objectArray',
                    beanConfig: this.createBeanConfig(VehicleStateEnum.IS_ABROAD),
                    caption: 'VEHICLE_USE_SECTION.FORM_FIELDS.isAbroad',
                    type: FieldType.Select,
                    displayInPreviewMode: true,
                    validators: [Validator.REQUIRED],
                    options: {
                        item: 'key',
                        label: { label: 'label' },
                        items: this.vehicleDataStateService.abroadUsageTimeDictionary.items,
                    },
                    select: {
                        dropdownPosition: 'bottom',
                        multiple: false,
                        searchable: true
                    },
                    initialValue: this.vehicleDataStateService.abroadUsageTimeDictionary.items.find(item => item.key === 'NONE').value
                },
                {
                    fieldKey: VehicleStateEnum.ACTUAL_MILEAGE,
                    caption: 'VEHICLE_USE_SECTION.FORM_FIELDS.actualMileage',
                    type: FieldType.TextField,
                    displayInPreviewMode: true,
                    validators: [
                        Validator.REQUIRED_NOT_BLANK,
                        {
                            name: Validator.PATTERN,
                            pattern: '^[0-9 ]*$'
                        },
                        {
                            name: Validator.MAX_LENGTH,
                            maxLength: 9 // 7 digits + separators (2)
                        },
                        {
                            name: Validator.MIN_LENGTH,
                            minLength: 2,
                        }],
                    // maskConfig: {
                    //   mask: 'separator',
                    //   dropSpecialCharacters: false,
                    // },
                    properties: {
                        mobileInputType: 'tel',
                        textTransform: {
                            type: 'separateAndConvertToNumber',
                            separatorConfig: {
                                charsChain: 3,
                                separator: ' '
                            }
                        },
                        //   dynamicSuffix: 'km'
                    },
                    maxlength: 9, // 7 digits + separators (2)
                    convertFormat: 'string',
                    analyticsConfig: {
                        includeFieldValue: true
                    }
                },
                {
                    fieldKey: VehicleModelConsts.FIRST_REGISTRATION_DATE,
                    caption: 'VEHICLE_DATA_SECTION.FORM_FIELDS.firstRegistrationDate',
                    type: FieldType.DateField,
                    validators: [Validator.REQUIRED],
                    displayInPreviewMode: true,
                    fullWidthInPreviewMode: true,
                    materialDateFieldConfig: {
                        startAt: () => this.vehicleDataStateService.getProductionDate(),
                        maxDate: this.vehicleDataStateService.getMaxFirstRegistrationDate(),
                        startView: 'multi-year'
                    },
                },
                {
                    fieldKey: VehicleDataEnum.IS_LEFT_HAND_DRIVE,
                    fieldsDataFormat: 'objectArray',
                    beanConfig: this.createBeanConfig(VehicleDataEnum.IS_LEFT_HAND_DRIVE),
                    caption: 'VEHICLE_USE_SECTION.FORM_FIELDS.isLeftHandDrive',
                    type: this.isNext ? FieldType.ButtonToggle : FieldType.Radio,
                    displayInPreviewMode: true,
                    validators: [Validator.REQUIRED],
                    radioConfig: [
                        {value: VehicleQuestionAnswer.LEFT_HAND_DRIVE_YES, label: 'VEHICLE_USE_SECTION.QUESTION_LEFT_HAND_DRIVE_ANSWER.yes'},
                        {value: VehicleQuestionAnswer.LEFT_HAND_DRIVE_NO, label: 'VEHICLE_USE_SECTION.QUESTION_LEFT_HAND_DRIVE_ANSWER.no'},
                    ],
                    radioInline: true,
                    initialValue: VehicleQuestionAnswer.LEFT_HAND_DRIVE_YES
                },
                {
                    fieldKey: VehicleDataEnum.IS_GAS_INSTALLATION,
                    fieldsDataFormat: 'objectArray',
                    beanConfig: this.createBeanConfig(VehicleDataEnum.IS_GAS_INSTALLATION),
                    caption: 'VEHICLE_USE_SECTION.FORM_FIELDS.isGasInstallation',
                    type: this.isNext ? FieldType.ButtonToggle : FieldType.Radio,
                    displayInPreviewMode: true,
                    validators: [Validator.REQUIRED],
                    radioConfig: [
                        {value: VehicleQuestionAnswer.GAS_INSTALLATION_NO, label: 'VEHICLE_USE_SECTION.QUESTION_ANSWER.no'},
                        {value: VehicleQuestionAnswer.GAS_INSTALLATION_YES, label: 'VEHICLE_USE_SECTION.QUESTION_ANSWER.yes'},
                    ],
                    radioInline: true,
                    initialValue: VehicleQuestionAnswer.GAS_INSTALLATION_NO
                },
                {
                    fieldKey: VehicleStateEnum.IS_VALID_CAR_INSPECTION,
                    fieldsDataFormat: 'objectArray',
                    beanConfig: this.createBeanConfig(VehicleStateEnum.IS_VALID_CAR_INSPECTION),
                    caption: 'VEHICLE_USE_SECTION.FORM_FIELDS.isValidCarInspection',
                    type: this.isNext ? FieldType.ButtonToggle : FieldType.Radio,
                    validators: [Validator.REQUIRED],
                    displayInPreviewMode: true,
                    radioConfig: [
                        {value: VehicleQuestionAnswer.VALID_CAR_INSPECTION_YES, label: 'VEHICLE_USE_SECTION.QUESTION_ANSWER.yes'},
                        {value: VehicleQuestionAnswer.VALID_CAR_INSPECTION_NO, label: 'VEHICLE_USE_SECTION.QUESTION_ANSWER.no'},
                    ],
                    initialValue: VehicleQuestionAnswer.VALID_CAR_INSPECTION_YES,
                    radioInline: true
                },
                {
                    fieldKey: VehicleDataEnum.VEHICLE_TYPE,
                    caption: 'VEHICLE_USE_SECTION.FORM_FIELDS.type',
                    type: FieldType.Select,
                    // validators: [Validator.REQUIRED],
                    options: {
                        item: 'key',
                        label: { label: 'label' },
                        items: []
                    },
                    select: {
                        dropdownPosition: 'bottom',
                        searchable: true
                    }
                },
                {
                    fieldKey: VehicleStateEnum.IS_LEASING,
                    fieldsDataFormat: 'objectArray',
                    beanConfig: this.createBeanConfig(VehicleStateEnum.IS_LEASING),
                    caption: 'VEHICLE_USE_SECTION.FORM_FIELDS.isLeasing',
                    type: this.isNext ? FieldType.ButtonToggle : FieldType.Radio,
                    displayInPreviewMode: true,
                    validators: [Validator.REQUIRED],
                    radioConfig: [
                        {value: VehicleQuestionAnswer.LEASING_NO, label: 'VEHICLE_USE_SECTION.QUESTION_ANSWER.no'},
                        {value: VehicleQuestionAnswer.LEASING_YES, label: 'VEHICLE_USE_SECTION.QUESTION_ANSWER.yes'},
                    ],
                    radioInline: true,
                    initialValue: VehicleQuestionAnswer.LEASING_NO
                },
                {
                    fieldKey: VehicleStateEnum.COUNTRY_OF_ORIGIN,
                    caption: 'VEHICLE_USE_SECTION.FORM_FIELDS.countryOfOrigin',
                    type: FieldType.Select,
                    validators: [],
                    displayInPreviewMode: true,
                    options: {
                        item: 'key',
                        label: { label: 'label' },
                        items: this.vehicleDataStateService.countryOfOriginDictionary.items,
                    },
                    select: {
                        dropdownPosition: 'bottom',
                        multiple: false,
                        searchable: true
                    }
                },
                {
                    fieldKey: VehicleDataEnum.IS_SERVICE_HISTORY,
                    fieldsDataFormat: 'objectArray',
                    beanConfig: this.createBeanConfig(VehicleDataEnum.IS_SERVICE_HISTORY),
                    caption: 'VEHICLE_USE_SECTION.FORM_FIELDS.isServiceHistory',
                    type: FieldType.TextField,
                    // validators: [Validator.REQUIRED]
                },
                {
                    fieldKey: InsuranceDataEnum.YOUNGEST_DRIVER_AGE,
                    caption: 'VEHICLE_USE_SECTION.FORM_FIELDS.youngestDriverAge',
                    type: FieldType.Select,
                    displayInPreviewMode: false,
                    // validators: [Validator.REQUIRED],
                    options: {
                        item: 'key',
                        label: { label: 'label' },
                        items: this.insuranceDataStateService.youngestDriverAge
                    },
                    select: {
                        dropdownPosition: 'bottom',
                        multiple: false,
                        searchable: true
                    }
                },
                {
                    fieldKey: VehicleStateEnum.PURCHASE_YEAR,
                    caption: 'VEHICLE_USE_SECTION.FORM_FIELDS.purchaseYear',
                    type: FieldType.DateField,
                    validators: [
                        Validator.REQUIRED,
                    ],
                    displayInPreviewMode: true,
                    materialDateFieldConfig: {
                        startView: 'multi-year' as DatepickerStartView,
                        type: MaterialDatepickerType.YEAR,
                        startAt: currentYear(),
                        datepickerToggleIcon: 'arrow_drop_down',
                        hideCalendarPeriodButton: true,
                        initMinDateWithStartAt: false,
                        minDate: this.vehicleDataStateService.getProductionDate() + '',
                        maxDate: currentYear() + '',
                        manualInputAllowed: true,
                        readonly: false,
                    }
                },
                {
                    fieldKey: VehicleStateEnum.PURCHASE_MONTH,
                    caption: 'VEHICLE_USE_SECTION.FORM_FIELDS.purchaseMonth',
                    type: FieldType.Select,
                    displayInEditableMode: false,
                    displayInPreviewMode: true,
                    validators: [],
                    options: {
                        item: 'key',
                        label: { label: 'label' },
                        items: []
                    },
                    select: {
                        dropdownPosition: 'bottom',
                        multiple: false,
                        searchable: true
                    }
                }
            ]
        };
        
        formConfig = this.addDynamicFields(formConfig);

        formConfig.fieldsConfig.forEach(fieldConfig => {
            this.predefined.addPredefinedValue(
                fieldConfig,
                this.predefined.values,
                formConfig.formKey,
                fieldConfig.fieldKey
            )
        });
        return formConfig;
    }

    private addDynamicFields(formConfig: FormConfig): FormConfig {
        if (this.isNext) {
            formConfig.fieldsConfig.push({
                fieldKey: VehicleStateEnum.ABROAD_IMPORTED,
                caption: 'VEHICLE_DATA_SECTION.FORM_FIELDS.abroadImported',
                type: FieldType.ButtonToggle,
                validators: [Validator.REQUIRED],
                displayInPreviewMode: true,
                radioInline: true,
                radioConfig: [
                    {
                        value: VehicleAbroadImported.ABROAD_IMPORTED_NO,
                        label: 'VEHICLE_USE_SECTION.QUESTION_ANSWER.no'
                    },
                    {
                        value: true,
                        label: 'VEHICLE_USE_SECTION.QUESTION_ANSWER.yes'
                    }
                ],
                // radioConfig: this.vehicleStateStateService.abroadImportedDictionary.items.map(item => ({
                //     value: item.key,
                //     label: item.label
                // })),
                initialValue: VehicleAbroadImported.ABROAD_IMPORTED_NO
            });
            formConfig.fieldsConfig.push({
                fieldKey: VehicleStateEnum.ABROAD_IMPORTED_TIME,
                caption: 'VEHICLE_DATA_SECTION.FORM_FIELDS.abroadImportedTime',
                type: FieldType.ButtonToggle,
                // validators: [Validator.REQUIRED],
                displayInPreviewMode: true,
                radioInline: true,
                radioConfig: [
                    {
                        value: VehicleAbroadImported.ABROAD_IMPORTED_OVER_12_MONTHS,
                        label: 'VEHICLE_USE_SECTION.ABROAD_IMPORTED_TIME.over12Months'
                    },
                    {
                        value: VehicleAbroadImported.ABROAD_IMPORTED_UNDER_12_MONTHS,
                        label: 'VEHICLE_USE_SECTION.ABROAD_IMPORTED_TIME.under12Months'
                    }
                ],
                // radioConfig: this.vehicleStateStateService.abroadImportedDictionary.items.map(item => ({
                //     value: item.key,
                //     label: item.label
                // })),
                // initialValue: VehicleAbroadImported.ABROAD_IMPORTED_OVER_12_MONTHS
            });
            formConfig.fieldsConfig.push({
                fieldKey: VehicleStateEnum.VEHICLE_CONDITION,
                caption: 'VEHICLE_DATA_SECTION.FORM_FIELDS.vehicleCondition',
                type: FieldType.ButtonToggle,
                validators: [Validator.REQUIRED],
                displayInPreviewMode: true,
                radioInline: true,
                radioConfig: this.vehicleStateStateService.vehicleConditionDictionary.items.map(item => ({
                    value: item.key,
                    label: item.label
                })),
                initialValue: this.vehicleStateStateService.vehicleConditionDictionary.items.find(item => item.key === 'NOT_DAMAGED').value
            });
        } else {
            formConfig.fieldsConfig.push({
                fieldKey: VehicleStateEnum.ABROAD_IMPORTED,
                caption: 'VEHICLE_DATA_SECTION.FORM_FIELDS.abroadImported',
                type: FieldType.Select,
                validators: [Validator.REQUIRED],
                displayInPreviewMode: true,
                options: {
                    item: 'key',
                    label: { label: 'label' },
                    items: this.vehicleStateStateService.abroadImportedDictionary.items,
                },
                select: {
                    dropdownPosition: 'bottom',
                    multiple: false,
                    searchable: true
                },
                initialValue: this.vehicleStateStateService.abroadImportedDictionary.items.find(item => item.key === 'ABROAD_IMPORTED_NO').value
            });
            formConfig.fieldsConfig.push({
                fieldKey: VehicleStateEnum.VEHICLE_CONDITION,
                caption: 'VEHICLE_DATA_SECTION.FORM_FIELDS.vehicleCondition',
                type: FieldType.Select,
                validators: [Validator.REQUIRED],
                displayInPreviewMode: true,
                options: {
                    item: 'key',
                    label: { label: 'label' },
                    items: this.vehicleStateStateService.vehicleConditionDictionary.items
                },
                select: {
                    dropdownPosition: 'bottom',
                    multiple: false,
                    searchable: true
                }
            });
        }

        if (this.vehicleStateStateService.damageDescriptionEnabled) {
            formConfig.fieldsConfig.push({
                fieldKey: VehicleStateEnum.DAMAGE_DESCRIPTION,
                caption: 'VEHICLE_DATA_SECTION.FORM_FIELDS.damageDescription',
                displayInPreviewMode: true,
                type: FieldType.TextArea
            });
        }
        
        return formConfig;
    }
}
